import React, {useCallback, useState} from "react";
import useForm from "rc-form-hooks";
import {useLoading} from "../../components/loading/LoadingProvider";
import {useHistory} from "react-router-dom";
import {setUserSkill} from "../../service";
import Input from "../../components/inputItem";
import useUserInfo from "../../routers/useUserInfo";
import {State} from "../../store/reducer";
import {useSelector} from "react-redux";

function Skills(){


    const userData = useUserInfo()
    const loading = useLoading()
    const his = useHistory()
    const skill = useSelector<State,State['skill']>(state => state.skill)

    const {getFieldDecorator, validateFields, errors, values} = useForm<{
        skill: string
    }>();

    const handleSubmit = useCallback((e: React.FormEvent) => {
        e.preventDefault();
        validateFields()
            .then(res => {
                if (userData && typeof values.skill === 'string') {
                    setUserSkill({
                        userId: userData.id,
                        skill: values.skill
                    }).then(res => {
                        if (res.code === 1) {
                            loading.showSuccess()
                            his.goBack()
                        }else{
                            loading.showError()
                        }
                    })
                }

            })
            .catch(e => console.error(e.message));
    }, [values])

    return <div className="skill">
        <form onSubmit={handleSubmit}>
            {
                getFieldDecorator('skill', {
                    rules: [{required: true, message: '请输入个人优势'}],
                    initialValue: skill
                })(<Input type={'text'} isTextArea={true} placeholder='一句话介绍自己，突出核心优势'
                          extraClass={['no-border-top', 'fill-width']} clear maxLen={500}
                          />)
            }
            {
                userData && <button type={'submit'} className="common-btn submit">确认</button>
            }
        </form>
    </div>
}

export default Skills
